import { useCallback, useEffect, useState } from 'react';
import { getSession, type SessionUser } from '@/services/session';

export interface UseSessionResult {
  user: SessionUser | null;
  loading: boolean;
  error: unknown;
  refresh: () => Promise<void>;
}

/**
 * 讀取當前 session。取得失敗（401 或 network）都回 user=null。
 */
export function useSession(): UseSessionResult {
  const [user, setUser] = useState<SessionUser | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>(null);

  const fetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const s = await getSession();
      setUser(s);
    } catch (e) {
      setError(e);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void fetch();
  }, [fetch]);

  return { user, loading, error, refresh: fetch };
}
